<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/dashboard" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Spread</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="container">
    <ion-img src="assets/images/logo.png" class="logo" />
    <div class="text">
      <h2 class="title">Invite Friends</h2>
      <p>Share your positive experiences and boost your commissions! Invite friends and colleagues to join the
        referral
        and benefits app – by spreading the word about GoSpread, you also unlock bonuses for every accepted
        invitation.
      </p>
    </div>
    <footer *ngIf="linkShare !== ''">
      <ion-button expand="block" shape="round" (click)="shareLink()">Spread it
      </ion-button>
      <ion-button expand="block" color="secondary" shape="round" (click)="copyLink()">Copy Link
      </ion-button>
    </footer>
  </div>
</ion-content>